import Vue from "vue";
import Vuex from "vuex";
import products from "./modules/products/index";
import productimages from "./modules/productimages/index";
import brands from "./modules/brands/index";
import suppliers from "./modules/suppliers/index";
import supplierorders from "./modules/suppliers/orders/index";
import subcategories from "./modules/subcategories/index";
import countries from "./modules/countries/index";
import users from "./modules/users/index";
import useraddresses from "./modules/users/addresses/index";
import userphones from "./modules/users/phones/index";
import categories from "./modules/categories/index";
import subcategorytypes from "./modules/subcategorytypes/index";
import surgeries from "./modules/surgeries/index";
import auth from "./modules/auth/index";
import orders from "./modules/orders/index";
import shipmentprofiles from "./modules/shipments/profiles/index";
import shipmentprofilerates from "./modules/shipments/rates/index";
import productstatuses from "./modules/products/status/index";
import finance from "./modules/finance/index";

Vue.use(Vuex);
const store = new Vuex.Store({
  modules: {
    auth,
    products,
    brands,
    suppliers,
    supplierorders,
    subcategories,
    countries,
    users,
    useraddresses,
    userphones,
    categories,
    subcategorytypes,
    productimages,
    surgeries,
    orders,
    shipmentprofiles,
    shipmentprofilerates,
    productstatuses,
    finance
  },
  state: {},
  actions: {},
  mutations: {},
  getters: {}
});
export default store;
